import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { init } from '@module-federation/runtime'
import './index.css'
import App from './App'
import { initRuntimeEndpoints } from './config/runtimeEndpoints'
import { installApiLogging } from './utils/apiLogger'

// Initialize Module Federation runtime — must happen before any loadRemote calls
// This sets up the shared dependency resolution and CSS injection handlers
init({
  name: 'shell_app',
  remotes: [],
});

// Import favicon
import favicon from '/icons/favicon.ico'

// Set favicon dynamically
const link = document.querySelector("link[rel~='icon']");
if (link) {
  link.href = favicon;
}

// Fix for vh units on mobile
function setVhVariable() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Set the variable initially and on resize
setVhVariable();
window.addEventListener('resize', setVhVariable);

// Global configuration for sharing with micro-frontends.
//
// `apiUrl` and `sseUrl` are NOT build-time values — the gateway and SSE hosts
// are regional and only known once /api/region has answered at login.
// initRuntimeEndpoints() seeds them from this device's cache when there is one
// (a returning visit), and AuthContext fills them in after a resolve when there
// is not. Remotes read window.__APP_CONFIG__ at module-eval, but only ever load
// behind ProtectedRoute — by which point both are pinned.
window.__APP_CONFIG__ = {
  version: '1.0.0',
  environment: import.meta.env.MODE
};

initRuntimeEndpoints();

// Observation only — wraps window.fetch to log one line out and one line back
// for API traffic. Never alters a request, a response or an error.
installApiLogging();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)